const state = {
  top: 0,
  pages: 0,
  threshold: 1,
  mouse: [0, 0],
  model1Pos: [-3.9, 0.2, -7.6],
  model2Pos: [1.8, 5.8, -9.8],
  model3Pos: [2.6, 12, -14],
  model4Pos: [7.5, 20.15, -14.5],
  model5Pos: [1, 26, -16.8],
  model6Pos: [-7.65, 32.4, -16.6],
  model7Pos: [-10.6, 40.5, -10.1],
  model8Pos: [-12.5, 49.5, -6.5],
  selectedModel: 0,
  zoomGlobal: false,
  lowMode: false,
  currentModel: 0,
  confirmLowFunctionCanceled: false
}

export default state
